/* eslint-disable */
export default {
  forward: 'Weiterl.',
  reply: 'Antwort',
  ignore: 'Ignorieren',
  toVoicemail: 'An Voicemail',
  answer: 'Antworten',
  answerAndEnd: 'Antw. u. beenden',
  answerAndHold: 'Antw. u. halten',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
